import React, { createContext } from 'react'

export type INotification = {
  message: string
  duration?: number
  type: 'success' | 'fail' | 'warning'
  reasons?: string[] | React.ReactElement[]
  done?: boolean
}

export interface INotificationContext {
  notifications: INotification[]
  setNotifications: React.Dispatch<React.SetStateAction<INotification[]>>
}

const NotificationContext = createContext<INotificationContext>({
  notifications: [],
  setNotifications: () => {},
})

export default NotificationContext
